<div
  class="product-layout container-xl d-flex justify-content-between flex-column flex-lg-row"
>
  <app-image-gallery
    class="d-none d-lg-flex"
    [product]="product"
  ></app-image-gallery>
  <app-meta class="ms-lg-auto ps-lg-5" [product]="product"></app-meta>
</div>
<div class="meta-layout">
  <!-- <app-bundle
    *ngIf="product.tags.includes('bundleable')"
    [product]="product"
  ></app-bundle> -->
  <div [appStoryblok]="_editable" *ngFor="let blok of story?.content?.body">
    <ndc-dynamic
      *ngIf="components"
      [ndcDynamicComponent]="components[blok.component]"
      [ndcDynamicInputs]="blok"
    >
    </ndc-dynamic>
  </div>
  <app-okendo *ngIf="!story?.content" [product]="product"></app-okendo>
  @defer {
  <app-drawer>
    <app-back-in-stock [product]="product"></app-back-in-stock>
  </app-drawer>
  } @placeholder {
  <div></div>
  }
</div>
<app-sticky-add-to-cart [product]="product"></app-sticky-add-to-cart>
